import odin from '@philips/odin';

import { DataContext, SubmittableFragmentContext } from '@philips-emr/tws-core/lib/component/context';

import FragmentNode from '../fragment-node';

import FragmentCustomProvider from './fragment-custom-provider';

interface Dependency {
  [k: string]: (...args: unknown[]) => void | unknown;
}

export interface Container {
  provide(className: string, create?: boolean): Dependency;
}

interface ProviderArgs {
  fragment: FragmentNode;
  dataContext: DataContext;
  submittableFragmentContext: SubmittableFragmentContext | null;
}

function provideContainer(args: ProviderArgs): Container {
  const { dataContext, fragment, submittableFragmentContext } = args;

  odin.bundle(fragment.getName()); // forces odin to create a bundle
  const customProvider = new FragmentCustomProvider({ dataContext, fragment, submittableFragmentContext });
  const container = odin.container(fragment.getName(), customProvider);

  return container;
}

export default provideContainer;
